// While the cat is away in the Capital the homestead panels make no sense (you can't build, hire, study or send an adventure from
// there), so BUILD / CITIZENS / CAREER / ADVENTURE are switched off — and any that was open is closed. They come back on at home.

import { Events, on } from './eventBus.js'

const RAIL = '[data-rail-build], [data-rail-pop], [data-rail-career], [data-rail-adventure]'
const AWAY_TIP = "You're away from home — return home to use this."

export function mountCapitalRailLock() {
  const apply = (away) => {
    document.querySelectorAll(RAIL).forEach((b) => {
      b.disabled = away
      b.setAttribute('aria-disabled', String(away))
      b.classList.toggle('away-locked', away)
      if (away) {
        if (b.dataset.homeTitle === undefined) b.dataset.homeTitle = b.title || ''
        b.title = AWAY_TIP
      } else if (b.dataset.homeTitle !== undefined) {
        b.title = b.dataset.homeTitle
        delete b.dataset.homeTitle
      }
    })
    if (away) document.querySelectorAll('[data-rail-panel].open').forEach((p) => p.classList.remove('open'))
  }
  on(Events.AwayChange, (p) => apply(!!p?.active)) // away in Capital City or in any land
  apply(document.body.classList.contains('in-capital') || document.body.classList.contains('in-land'))
}
